import AcccountHostItem from '../../components/AccountHostItem';
import Nav from '../../components/Nav';
import { useAxios } from '../../utils/hook/useAxios';
import './mc-account-profile.css';

function AccountSetting() {
  const axios = useAxios();
  const userData = JSON.parse(window.localStorage.getItem('me'));

  return (
    <main className="mc-home mc-account-page">
      <div className="container mc-container">
        <Nav />

        <div className="mc-account-shell">
          <div className="mc-account-head">
            <div>
              <h1 className="mc-account-title">Paramètres</h1>
              <p className="mc-prof-subtitle">
                Vos informations personnelles et les documents de votre compte hôte.
              </p>
            </div>
          </div>

          <AcccountHostItem />
        </div>
      </div>
    </main>
  );
}

export default AccountSetting;
